export default "__VITE_ASSET__c8077dac__"